<template>
  <div id="LeaseRevenueForecast">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Lease Revenue Forecast</div>
          <div class="web-action-btn btn-groups text-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
              <i class="fp-export"></i> Export
            </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'leaseContract'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'leaseContract'" :position="'top'">
                </custom-pagination>

                <vue-good-table
                  mode="remote"
                  ref="leaseRevenueForecastTable"
                  title="Lease Revenue Forecast"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                >
                </vue-good-table>
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import LoadingContent from "./LoadingContent.vue";
  Vue.component("loading-content",LoadingContent);

  
  
  

  import {commonMixins} from "../mixins/commonMixins";
  import {dataTableMixins} from "../mixins/dataTableMixins";
  export default {
    name: "LeaseRevenueForecastReport",
    metaInfo(){
      return {
        title : 'Lease Revenue Forecast Report | FleetPro Application'
      }
    },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
      cantAccessPage:"",
      loading: false,
      action:'list',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
        {
          label: 'Start Date',
          field: 'start_date',
          hidden:true,
          fpFieldType:"date",
          filterable: true,
          filterDropdownItems: ['is'],
        },
        {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
        },
        {
          label: 'Customer Unit Number',
          field: 'cust_unit_no',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
        },
        {
          label: 'Serial Number',
          field: 'vin',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
        },
        {
          label: 'Contract Type',
          field: 'conType',
          fpFieldType:"option",
          filterable: true,
        },
        {
          label: 'Agreement',
          field: 'agreement_no',
          filterable: false,
          fpFieldType:"text",
        },
        {
          label: 'In Service Date',
          field: 'effective_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: false,
        },
        {
          label: 'Billing Frequency',
          field: 'frequency',
          fpFieldType:"integer",
          filterable: false,
        },
        {
          label: "Customer",
          field: "customer",
          filterable: true,
          fpFieldType:"text",
          hidden:false,
        },
        {
          label: "Customer Number",
          field: "customer_number",
          filterable: true,
          fpFieldType:"text",
          hidden:true,
        },
        {
          label: 'Location',
          field: 'location',
          fpFieldType:"option",
          filterable: true,
        },
        {
          label: 'Contract Expiry Date',
          field: 'expiry_date',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: false,
        },
        {
          label: 'Terms',
          field: 'contract_term',
          fpFieldType:"integer",
          hidden:false,
          filterable: false,
        },
        {
          label: 'Contract Status',
          field: 'contract_status',
          fpFieldType:"option",
          filterable: false,
        },
        {
          label: 'Unit Year',
          field: 'year',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
        },
        {
          label: 'Make',
          field: 'manufacturer_code',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
        },
        {
          label: 'Model',
          field: 'model',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
        },
        {
          label: 'Equipment Type',
          field: 'equip_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
        },
        {
          label: 'Pool',
          field: 'pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
        },
        {
          label: 'Sales Person',
          field: 'user',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
        },
        {
          label: 'Fixed Annual Revenue',
          field: 'fixed_rev',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
        },
        {
          label: 'Variable Annual Revenue',
          field: 'variable_rev',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable: false,
        },
        {
          label: 'Total Annual Revenue',
          field: 'total_rev',
          fpFieldType:"integer",
          type: 'number',
          filterable: false,
          hidden:false,
          sortable:false,
        },
        {
          label: 'Fixed Rate',
          field: 'fixed_rate',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Distance Variable Rate',
          field: 'distance_rate',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Reefer Hour Variable Rate',
          field: 'rfhour_rate',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Park Rate',
          field: 'park_rate',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Reefer Hour Estimated Usage',
          field: 'estimated_hour',
          // type : 'number',
          filterable: false,
          fpFieldType:"integer",
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Remaining Months',
          field: 'remaining_month',
          filterable: false,
          fpFieldType:"integer",
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Revenue Year 1',
          field: 'revenue_year_1',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Revenue Year 2',
          field: 'revenue_year_2',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Revenue Year 3',
          field: 'revenue_year_3',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Revenue Year 4',
          field: 'revenue_year_4',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Revenue Year 5',
          field: 'revenue_year_5',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
        {
          label: 'Revenue Year > 5',
          field: 'revenue_year_6',
          filterable: false,
          fpFieldType:"integer",
          type : 'number',
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
        },
      ],
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
      permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
          if(permissions.name == 'lease_contract_report') {
            self.cantAccessPage = true;
          }
        });
        if(self.cantAccessPage == ''){
          self.cantAccessPage = false;
        }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{
      cancelAll: function (cancelAll) {
        this.$refs.leaseContractReportTable.unselectAllInternal();
      },
      // exportReports: function() {
      //     var self = this;
      //     this.action = "export";
      //     this.loadList();
      // },
      loadList: function(){
        var self = this;
        self.loading = true;
        var date = new Date();
        var offset = date.getTimezoneOffset();

        $.ajax({
          url: process.env.ROOT_API + "/lease-revenue-forecast-report/list",
          type: "POST",
          crossDomain: true,
          headers: this.ajxHeaders,
          dataType: "json",
          data: {
            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: this.serverParams.columnFilters,
            sort: this.serverParams.sort,
            offset: offset,
            action:self.action


          },
          success: function(data) {
            self.loading = false;
            //console.log(data.content[0]["id"]);
            console.log(data.content.row);
            if (data.status == "success") {
              if (self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                  alert(data.message);
                } else {
                  if ( self.action == "export" ) {

                    self.excel = data.content.web;
                    var save = document.createElement("a");
                    save.href = self.excel;
                    save.download = data.content.web;
                    save.target = "_blank";

                    document.body.appendChild(save);
                    save.click();
                    document.body.removeChild(save);
                  } else {

                    self.batchProcess = 1;
                    self.batchNum = data.content;
                  }
                }

                self.action = "list";
                // self.loadList();

              } else {

                if (data.content.row != undefined) {
                  self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
              }


            }
          },
          error: function(jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'lease-contract-list')
          }
        });


      }

    }

  }
</script>



// WEBPACK FOOTER //
// src/components/LeaseRevenueForecastReport.vue